export default "__VITE_ASSET__bZb5Ps8W__"